export default __webpack_public_path__ + "static/media/slideup3.ac80dcd4.jpeg";